import { Component, Inject } from '@angular/core';

import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FluidFlowModelListItemDto } from '../../../core/models/simulation.model';

@Component({
  selector: 'app-select-fluid-model-popup',
  standalone: true,
  imports: [
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule
],
  templateUrl: './select-fluid-model-popup.component.html',
  styleUrl: './select-fluid-model-popup.component.scss',
})
export class SelectFluidModelPopupComponent {
  displayedColumns: string[] = [
    'name',
    'direction',
    'flowUnits',
    'interfacialTension',
    'primaryDrainage',
    'firstImbibition',
  ];
  fluidModels: FluidFlowModelListItemDto[];
  selectedFluidModel: FluidFlowModelListItemDto | null = null;

  constructor(
    public dialogRef: MatDialogRef<SelectFluidModelPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { fluidModels: FluidFlowModelListItemDto[] },
  ) {
    this.fluidModels = data.fluidModels;
  }

  onRowClick(model: FluidFlowModelListItemDto): void {
    this.selectedFluidModel = this.selectedFluidModel?.id === model.id ? null : model;
  }

  formatRange(min: number, max: number): string {
    if (min === 0 && max === 0) return 'Not Available';
    return `${min.toFixed(3)} to ${max.toFixed(3)}`;
  }

  selectFluidModel(): void {
    if (this.selectedFluidModel) {
      this.dialogRef.close(this.selectedFluidModel);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
